/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ToolbarTitle } from "../../../../../ui/components/Toolbar/ToolbarTitle";

export interface IConfigEditorEditOutlineToolbarProps {
	className?: string;
}

export const ConfigEditorEditOutlineToolbar: React.FC<IConfigEditorEditOutlineToolbarProps> = ({
	className
}) => {
	const baseClass = BEM("edt-config-editor-edit-outline-toolbar");

	if (className) {
		baseClass.add(className);
	}

	return (
		<>
			<ToolbarTitle>Settings</ToolbarTitle>
		</>
	);
};
